module.exports = __webpack_public_path__ + "img/officia-logo.0ac053c2.png";